import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { constructionPartsRoutes } from './construction-parts.routes';
import { provideConstructionPartsGlobals } from './construction-parts.globals';

export const SOFTLINE_PERMISSION_GEWERBE_CONSTRUCTION_PARTS = 'ROLE_CONSTRUCTION_PARTS';

export function provideConstructionPartsModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'gewerbe/constructionParts',
        title: 'Bauelemente',
        icon: 'fa-regular fa-user-helmet-safety',
        route: '/construction-parts',
        permission: SOFTLINE_PERMISSION_GEWERBE_CONSTRUCTION_PARTS,
        color: 'bg-warning text-black',
        group: getModuleGroupByName('Gewerbe'),
      },
      withSoftAppsModuleRoutes({ app: constructionPartsRoutes }),
      withSoftAppsModuleInfo({
        library: '@softapps/gewerbe/construction-parts',
        description: 'Bauelemente verwalten.',
      })
    ),
    ...provideConstructionPartsGlobals(),
  ];
}
